import { render, staticRenderFns } from "./SensorTable.vue?vue&type=template&id=15cc32ce&"
import script from "./SensorTable.vue?vue&type=script&lang=js&"
export * from "./SensorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports